import { useState } from "react";
import { HiChevronUp, HiChevronDown } from "react-icons/hi";
import { isMobile } from "utils/storeHube/helpers";

// Sección colapsable del detalle de hallazgo/tarea. Extraído de TicketContent
// para compartirlo entre las vistas inbox (tickets) y mytasks (tickets-mytasks)
// sin import circular ni definición duplicada.
export const TicketSection = ({
	title,
	icon,
	children,
	titleSize: Title = "h6",
	ticketClose,
	collapsed,
	defaultExpanded,
}) => {
	const [isExpanded, setIsExpanded] = useState(
		defaultExpanded !== undefined ? defaultExpanded : (isMobile() && collapsed) ? false : true
	);

	return (
		<div className="flex mb-5">
			<div className="text-xl">{icon}</div>
			<div className=" rtl:mr-2 w-full">
				<div className="flex items-center gap-2">
					<Title>{title}</Title>
				</div>
				<div className={`transition-all duration-300 ${isExpanded ? 'opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
					}`}>
					{children}
				</div>
				{
					collapsed && <div className=" w-full flex justify-center items-center cursor-pointer border-t-[1px]  border-gray-300 mt-2"
						onClick={() => setIsExpanded(!isExpanded)}>
						{isExpanded ?
							<HiChevronUp className=" mt-1  text-lg" /> :
							<HiChevronDown className="mt-1 text-lg" />}
					</div>
				}
			</div>
		</div>
	);
};

export default TicketSection;
